export default __webpack_public_path__ + "static/media/gallery-23.0d86fc78.jpg";